module.exports = __webpack_public_path__ + "img/RX106M-1.264.c69aaa79.png";